import type { ReactNode } from "react";
import { cn } from "@/shared/lib/cn";

export interface ProductDetailContainerProps {
  children: ReactNode;
  /** Solo para el ritmo vertical. El ancho y los márgenes no se tocan. */
  className?: string;
}

/**
 * El ancho de lectura de la ficha: `max-w-6xl` con 16 / 24 / 32 px de
 * margen, exactamente el `main` del original.
 *
 * ── Existe porque el estandarte SE SALE ──────────────────────────────
 * Antes la ficha entera vivía dentro de un solo contenedor con margen, y
 * por eso el estandarte se veía como una tarjeta metida en la página en
 * vez de como una portada a sangre. Ahora el estandarte se pinta suelto,
 * a lo ancho de la ventana, y TODO lo demás —miniaturas, compra,
 * editorial, aviso legal— se mete aquí.
 *
 * ── Y por eso lo usan también los otros tres estados ─────────────────
 * El esqueleto, el 404 y el aviso de error no tienen estandarte, así que
 * necesitan quien les ponga el margen. Si cada uno se lo pusiera por su
 * cuenta habría cuatro anchos que se van separando con el tiempo.
 */
export function ProductDetailContainer({
  children,
  className,
}: ProductDetailContainerProps) {
  return (
    <div className={cn("mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8", className)}>
      {children}
    </div>
  );
}
